export const PRO_COPY = {
  kicker: 'Yona Pro',
  title: 'Yona Pro',
  blurb: 'Clubs and ground-management tools. $5/month.',
  upgrade: 'Upgrade',
  dismiss: 'Not now',
};

export const PRO_ACCOUNT_PATH = '/profile/account';
